module.exports = {
	"ha": "vcha",
	"id": 5.2,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 380,
			"height": 390,
			"marginTop": 100,
			"marginLeft": 10,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "Figure 5.2 Estimated Cascade of Care for Vancouver Coastal Health by Sex, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">7</sup>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -40
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous<br>Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -40
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.41035856573706,
						"dataLabels": {
							"enabled": true,
							"format": "3912",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.87749003984064,
						"dataLabels": {
							"enabled": true,
							"format": "3489",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.38745019920319,
						"dataLabels": {
							"enabled": true,
							"format": "3389",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.30776892430279,
						"dataLabels": {
							"enabled": true,
							"format": "3185",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 68.4511952191235,
						"dataLabels": {
							"enabled": true,
							"format": "2749",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 92.27871939736346,
						"dataLabels": {
							"enabled": true,
							"format": "490",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.3954802259887,
						"dataLabels": {
							"enabled": true,
							"format": "480",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.57062146892656,
						"dataLabels": {
							"enabled": true,
							"format": "465",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.60263653483992,
						"dataLabels": {
							"enabled": true,
							"format": "428",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 54.61393596986818,
						"dataLabels": {
							"enabled": true,
							"format": "290",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.589641434262946,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -10.81288343558282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.8661507595299507,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.019474771318977,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.689167974882267,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -7.721280602636538,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.0408163265306145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.95698924731183,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -32.242990654205606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Male<br>n=4016"
			},
			{
				"x": 9,
				"text": "Female<br>n=531"
			}
		],
		"dataTable": {
			"Male": [
				4016,
				3912,
				3489,
				3389,
				3185,
				2749
			],
			"Female": [
				531,
				490,
				480,
				465,
				428,
				290
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_2.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_2.json
// module id = 303
// module chunks = 0